const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const OpsUser = require("../../core/vault/OpsUser");
const CreateAccountForm = require("./CreateAccountForm");
const OpsCart = require("../vault/OpsCart");
const CopyTable = require("../data/CopyTable");

const styles = require("./styles/PageRedeemSubscription.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "RedeemSubscriptionAccount",

		propTypes: {
			cart: PT.object.isRequired,
			user: PT.object.isRequired,
			onContinue: PT.func.isRequired,
			account: PT.object,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		vaultEvents: {
			accountDoesNotExist: function() {
				this.props.onContinue();
			},
		},

		getInitialState: function() {
			return {
				errorCode: "",
			};
		},

		onUsePlatformAccount: function() {
			this.props.dispatch({
				type: AT.USE_PLATFORM_ACCOUNT,
				emitEvent: "accountDoesNotExist",
			});
		},

		onSubmitNewAccount: function() {
			const {email, password} = OpsCart.getFormSection(
				this.props.cart,
				"account"
			);
			const reqData = {
				type: AT.CHECK_USER_EXISTS_REQUEST,
				email,
				password,
			};
			this.props.dispatch(reqData);
		},

		startLogin: function() {
			this.props.dispatch({
				type: AT.START_OFFICE_LOGIN,
			});
		},

		render: function() {
			const {user} = this.props;
			const accountStepCopy = CopyTable.getRedeemAccountStepCopy(
				styles,
				this.startLogin
			);
			const isParent = OpsUser.hasParentRole(user);
			const isLoggedIn = OpsUser.isLoggedIn(user);
			let mainContent;
			let subtitle;
			let titleText;
			if (isParent) {
				this.props.onContinue();
				return null;
			} else if (isLoggedIn) {
				if (
					OpsUser.isPlatformGuest(user) &&
					!OpsUser.isRestrictedPlatformUser(user)
				) {
					titleText = accountStepCopy.title;
					subtitle = accountStepCopy.description;
					mainContent = (
						<CreateAccountForm
							cart={this.props.cart}
							user={this.props.user}
							onContinue={this.onUsePlatformAccount}
							key={"needsParent"}
						/>
					);
				} else {
					// It should never get here since this case is handled in the function
					// renderNonParentContent of PageRedeemSubscription.jsx,
					// but leaving this here just in case
					titleText = "Sign into your parent account";
					mainContent = (
						<div className={styles.bodyText}>
							In order to use a subscription code, please either sign in with a
							Parent Account or sign out.
						</div>
					);
				}
			} else {
				titleText = accountStepCopy.title;
				subtitle = accountStepCopy.description;
				mainContent = (
					<CreateAccountForm
						cart={this.props.cart}
						user={this.props.user}
						onContinue={this.onSubmitNewAccount}
						key={"needsParent"}
					/>
				);
			}

			return (
				<div className={styles.sectionWrapper}>
					<h2 className={styles.title}>{titleText}</h2>
					{subtitle}
					{mainContent}
				</div>
			);
		},
	})
);
